import { StyleMap } from 'site/Renderer/hooks/useStyleMap'
import { z } from 'zod/v4'

const PropsParams = z.record(z.string(), z.unknown())

const createComponentSchema = <
  TDes extends string,
  TProps extends z.core.SomeType
>(
  des: TDes,
  props: TProps
) =>
  z
    .object({
      des: z.literal(des),
      order: z.string(),
      uuid: z.string(),
      props: z.intersection(
        props,
        z.object({
          styleMap: z.custom<StyleMap>().optional()
        })
      ),
      props_params: PropsParams.optional()
    })
    .meta({
      title: des
    })

export default createComponentSchema
